// src/versionCheck.js
const APP_VERSION =  import.meta.env.VITE_APP_VERSION; // Update this on each release
const savedVersion = localStorage.getItem("app_version");

if (savedVersion !== APP_VERSION) {
    console.log("[Cache-Bust] New app version detected. Clearing caches...");

    // Clear Cache API caches (used by service workers)
    if ('caches' in window) {
        caches.keys().then(names => {
            names.forEach(name => {
                caches.delete(name).then(deleted => {
                    if (deleted) console.log(`[Cache-Bust] Deleted cache: ${name}`);
                });
            });
        });
    }

    // Unregister all service workers
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(registrations => {
            registrations.forEach(reg => {
                reg.unregister().then(success => {
                    if (success) console.log("[Cache-Bust] Service worker unregistered");
                });
            });
        });
    }

    // Update localStorage with the new version
    localStorage.setItem("app_version", APP_VERSION);

    // Force reload to get fresh assets
    window.location.reload();
}
